import script from "./VinDecoder.vue?vue&type=script&setup=true&lang=js"
export * from "./VinDecoder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__